import Hero from "@/components/Hero";
import TrustStrip from "@/components/TrustStrip";
import LiveRateSection from "@/components/LiveRateSection";
import WhyChoose from "@/components/WhyChoose";
import HowItWorks from "@/components/HowItWorks";
import SeoContent from "@/components/SeoContent";
import CtaBanner from "@/components/CtaBanner";
import Faq from "@/components/Faq";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home({ rate }) {
    usePageMeta({
        title: "DtOrbit – Best USDT to INR Exchange | Fast & Secure USDT to INR",
        description:
            "Exchange USDT to INR with DtOrbit at competitive live rates. Fast, secure and simple USDT to INR exchange with reliable processing and easy INR payouts.",
        path: "/",
    });

    return (
        <>
            <Hero rate={rate} />
            <TrustStrip />
            <LiveRateSection rate={rate} />
            <WhyChoose />
            <HowItWorks />
            <SeoContent />
            <CtaBanner />
            <Faq />
        </>
    );
}
